module.exports = __webpack_public_path__ + "img/09.5f67b670.webp";